export class DownloadStatusVO {
  id: string;
  nome: string;
  numeroProtocollo: string;
  annoProtocollo: string;
  percentDone: number;
  startTime: any;
  endTime: any;
  currTime: any;
  prevTime: any;
  speed: number = 0;
  bytesReceied: number = 0;
  oldbytes: number = 0;
  unit: string = "Mbps";
}
